import React, { useState } from 'react'
import * as PosService from '../../Services/pos-service'
import * as ClaimService from '../../Services/claim-service';
import { t } from 'i18next';
import { CustomAutocomplete } from '../../Components/custom-combobox/CustomAutocomplete';
function PosRequestTakePolicy({ setObjectDto, policyNo, setPolicyNo, setLoading }) {
    const [listPo, setListPo] = useState([]);
    if (listPo.length === 0) ClaimService.getListPolicyNumber(setListPo, setObjectDto);
    return (
        <fieldset className="policy-infor" style={{ display: "block" }}>
            <div className="col-md-12 form-group">
                <label className="col-md-4 required">{t("policynumber")}</label>
                <div className="col-md-8">
                    <CustomAutocomplete placeholder={"Danh sách hợp đồng"} value={policyNo} data={listPo}
                        handleChange={(e) => PosService.handleChangeEventTextContent(e, setPolicyNo)}
                    />
                </div>
                <div className="footer-box-bg col-md-12">
                    <a id="btnCheck" className="btn-common btn-search description-small-customer" href
                        onClick={() => {
                            setLoading(true);
                            PosService.HandleVerifyToken(policyNo, setObjectDto, setLoading);
                        }} >
                        <i className="fa fa-info" aria-hidden="true" />{" "}
                        <span>{t('access')}</span>
                    </a>
                </div>
            </div>
        </fieldset>
    )
}

export default PosRequestTakePolicy